// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/password_push/v1/password_push_flow.proto" (package "c1.api.password_push.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { FieldMask } from "../../../../google/protobuf/field_mask";
// ====== Messages ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowRule
 */
export interface PasswordPushFlowRule {
    /**
     * @generated from protobuf field: int32 min_character_count = 1
     */
    minCharacterCount: number;
    /**
     * @generated from protobuf field: int32 max_character_count = 2
     */
    maxCharacterCount: number;
    /**
     * @generated from protobuf field: bool require_uppercase = 3
     */
    requireUppercase: boolean;
    /**
     * @generated from protobuf field: bool require_numbers = 4
     */
    requireNumbers: boolean;
    /**
     * @generated from protobuf field: bool require_special_characters = 5
     */
    requireSpecialCharacters: boolean;
    /**
     * @generated from protobuf field: bool require_lowercase = 6
     */
    requireLowercase: boolean;
    /**
     * @generated from protobuf oneof: character_rules
     */
    characterRules: {
        oneofKind: "noRestrictions";
        /**
         * @generated from protobuf field: bool no_restrictions = 100
         */
        noRestrictions: boolean;
    } | {
        oneofKind: "customCharacters";
        /**
         * @generated from protobuf field: string custom_characters = 101
         */
        customCharacters: string;
    } | {
        oneofKind: "excludedCharacters";
        /**
         * @generated from protobuf field: string excluded_characters = 102
         */
        excludedCharacters: string;
    } | {
        oneofKind: undefined;
    };
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlow
 */
export interface PasswordPushFlow {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 4 [deprecated = true]
     */
    rule?: PasswordPushFlowRule;
    /**
     * @generated from protobuf field: string password_policy_id = 5
     */
    passwordPolicyId: string;
    /**
     * @generated from protobuf field: bool visible_to_everyone = 6
     */
    visibleToEveryone: boolean;
}
/**
 * ====== Password Policies ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicy
 */
export interface PasswordPolicy {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 4
     */
    rule?: PasswordPushFlowRule;
    /**
     * Whether this password policy is a builtin system policy. Builtin system policies cannot be deleted.
     *
     * @generated from protobuf field: bool system_builtin = 5
     */
    systemBuiltin: boolean;
}
// ====== Create ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateRequest
 */
export interface PasswordPushFlowServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @deprecated
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 3 [deprecated = true]
     */
    rule?: PasswordPushFlowRule;
    /**
     * @generated from protobuf field: string password_policy_id = 4
     */
    passwordPolicyId: string;
    /**
     * @generated from protobuf field: bool visible_to_everyone = 5
     */
    visibleToEveryone: boolean;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateResponse
 */
export interface PasswordPushFlowServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1
     */
    passwordPushFlow?: PasswordPushFlow;
}
// ====== Get ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetRequest
 */
export interface PasswordPushFlowServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetResponse
 */
export interface PasswordPushFlowServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1
     */
    passwordPushFlow?: PasswordPushFlow;
}
// ====== Update ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateRequest
 */
export interface PasswordPushFlowServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1
     */
    passwordPushFlow?: PasswordPushFlow;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateResponse
 */
export interface PasswordPushFlowServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1
     */
    passwordPushFlow?: PasswordPushFlow;
}
// ====== Delete ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteRequest
 */
export interface PasswordPushFlowServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteResponse
 */
export interface PasswordPushFlowServiceDeleteResponse {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
// ====== Initiate Password Push Flow ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateRequest
 */
export interface PasswordPushFlowServiceInitiateRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2
     */
    passwordPushFlowId: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateResponse
 */
export interface PasswordPushFlowServiceInitiateResponse {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string password_push_flow_invocation_id = 3
     */
    passwordPushFlowInvocationId: string;
    /**
     * @generated from protobuf field: string jwk = 4
     */
    jwk: string;
}
// ====== Complete Password Push Flow ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteRequest
 */
export interface PasswordPushFlowServiceCompleteRequest {
    /**
     * @generated from protobuf field: string target_user_id = 1
     */
    targetUserId: string;
    /**
     * @generated from protobuf field: string password_push_flow_id = 2
     */
    passwordPushFlowId: string;
    /**
     * @generated from protobuf field: string password_push_flow_invocation_id = 3
     */
    passwordPushFlowInvocationId: string;
    /**
     * @generated from protobuf field: string jwe_encrypted_password = 4
     */
    jweEncryptedPassword: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteResponse
 */
export interface PasswordPushFlowServiceCompleteResponse {
}
/**
 * ====== Password Policies ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateRequest
 */
export interface PasswordPolicyServiceCreateRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPushFlowRule rule = 3
     */
    rule?: PasswordPushFlowRule;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateResponse
 */
export interface PasswordPolicyServiceCreateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1
     */
    passwordPolicy?: PasswordPolicy;
}
/**
 * ====== Get Password Policy ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetRequest
 */
export interface PasswordPolicyServiceGetRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetResponse
 */
export interface PasswordPolicyServiceGetResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1
     */
    passwordPolicy?: PasswordPolicy;
}
/**
 * ====== Update Password Policy ======
 *
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateRequest
 */
export interface PasswordPolicyServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1
     */
    passwordPolicy?: PasswordPolicy;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2
     */
    updateMask?: FieldMask;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateResponse
 */
export interface PasswordPolicyServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.password_push.v1.PasswordPolicy password_policy = 1
     */
    passwordPolicy?: PasswordPolicy;
}
// ====== Delete Password Policy ======

/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteRequest
 */
export interface PasswordPolicyServiceDeleteRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
}
/**
 * @generated from protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteResponse
 */
export interface PasswordPolicyServiceDeleteResponse {
}
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowRule$Type extends MessageType<PasswordPushFlowRule> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowRule", [
            { no: 1, name: "min_character_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "max_character_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "require_uppercase", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "require_numbers", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 5, name: "require_special_characters", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 6, name: "require_lowercase", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "no_restrictions", kind: "scalar", oneof: "characterRules", T: 8 /*ScalarType.BOOL*/ },
            { no: 101, name: "custom_characters", kind: "scalar", oneof: "characterRules", T: 9 /*ScalarType.STRING*/ },
            { no: 102, name: "excluded_characters", kind: "scalar", oneof: "characterRules", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowRule>): PasswordPushFlowRule {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.minCharacterCount = 0;
        message.maxCharacterCount = 0;
        message.requireUppercase = false;
        message.requireNumbers = false;
        message.requireSpecialCharacters = false;
        message.requireLowercase = false;
        message.characterRules = { oneofKind: undefined };
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowRule>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowRule): PasswordPushFlowRule {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 min_character_count */ 1:
                    message.minCharacterCount = reader.int32();
                    break;
                case /* int32 max_character_count */ 2:
                    message.maxCharacterCount = reader.int32();
                    break;
                case /* bool require_uppercase */ 3:
                    message.requireUppercase = reader.bool();
                    break;
                case /* bool require_numbers */ 4:
                    message.requireNumbers = reader.bool();
                    break;
                case /* bool require_special_characters */ 5:
                    message.requireSpecialCharacters = reader.bool();
                    break;
                case /* bool require_lowercase */ 6:
                    message.requireLowercase = reader.bool();
                    break;
                case /* bool no_restrictions */ 100:
                    message.characterRules = {
                        oneofKind: "noRestrictions",
                        noRestrictions: reader.bool()
                    };
                    break;
                case /* string custom_characters */ 101:
                    message.characterRules = {
                        oneofKind: "customCharacters",
                        customCharacters: reader.string()
                    };
                    break;
                case /* string excluded_characters */ 102:
                    message.characterRules = {
                        oneofKind: "excludedCharacters",
                        excludedCharacters: reader.string()
                    };
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowRule, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* int32 min_character_count = 1; */
        if (message.minCharacterCount !== 0)
            writer.tag(1, WireType.Varint).int32(message.minCharacterCount);
        /* int32 max_character_count = 2; */
        if (message.maxCharacterCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.maxCharacterCount);
        /* bool require_uppercase = 3; */
        if (message.requireUppercase !== false)
            writer.tag(3, WireType.Varint).bool(message.requireUppercase);
        /* bool require_numbers = 4; */
        if (message.requireNumbers !== false)
            writer.tag(4, WireType.Varint).bool(message.requireNumbers);
        /* bool require_special_characters = 5; */
        if (message.requireSpecialCharacters !== false)
            writer.tag(5, WireType.Varint).bool(message.requireSpecialCharacters);
        /* bool require_lowercase = 6; */
        if (message.requireLowercase !== false)
            writer.tag(6, WireType.Varint).bool(message.requireLowercase);
        /* bool no_restrictions = 100; */
        if (message.characterRules.oneofKind === "noRestrictions")
            writer.tag(100, WireType.Varint).bool(message.characterRules.noRestrictions);
        /* string custom_characters = 101; */
        if (message.characterRules.oneofKind === "customCharacters")
            writer.tag(101, WireType.LengthDelimited).string(message.characterRules.customCharacters);
        /* string excluded_characters = 102; */
        if (message.characterRules.oneofKind === "excludedCharacters")
            writer.tag(102, WireType.LengthDelimited).string(message.characterRules.excludedCharacters);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowRule
 */
export const PasswordPushFlowRule = new PasswordPushFlowRule$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlow$Type extends MessageType<PasswordPushFlow> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlow", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rule", kind: "message", T: () => PasswordPushFlowRule },
            { no: 5, name: "password_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlow>): PasswordPushFlow {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.passwordPolicyId = "";
        message.visibleToEveryone = false;
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlow>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlow): PasswordPushFlow {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushFlowRule rule = 4 [deprecated = true] */ 4:
                    message.rule = PasswordPushFlowRule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
                    break;
                case /* string password_policy_id */ 5:
                    message.passwordPolicyId = reader.string();
                    break;
                case /* bool visible_to_everyone */ 6:
                    message.visibleToEveryone = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlow, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* c1.api.password_push.v1.PasswordPushFlowRule rule = 4 [deprecated = true]; */
        if (message.rule)
            PasswordPushFlowRule.internalBinaryWrite(message.rule, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* string password_policy_id = 5; */
        if (message.passwordPolicyId !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.passwordPolicyId);
        /* bool visible_to_everyone = 6; */
        if (message.visibleToEveryone !== false)
            writer.tag(6, WireType.Varint).bool(message.visibleToEveryone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlow
 */
export const PasswordPushFlow = new PasswordPushFlow$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicy$Type extends MessageType<PasswordPolicy> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicy", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "rule", kind: "message", T: () => PasswordPushFlowRule },
            { no: 5, name: "system_builtin", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicy>): PasswordPolicy {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.systemBuiltin = false;
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicy>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicy): PasswordPolicy {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushFlowRule rule */ 4:
                    message.rule = PasswordPushFlowRule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
                    break;
                case /* bool system_builtin */ 5:
                    message.systemBuiltin = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicy, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* c1.api.password_push.v1.PasswordPushFlowRule rule = 4; */
        if (message.rule)
            PasswordPushFlowRule.internalBinaryWrite(message.rule, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* bool system_builtin = 5; */
        if (message.systemBuiltin !== false)
            writer.tag(5, WireType.Varint).bool(message.systemBuiltin);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicy
 */
export const PasswordPolicy = new PasswordPolicy$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCreateRequest$Type extends MessageType<PasswordPushFlowServiceCreateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "message", T: () => PasswordPushFlowRule },
            { no: 4, name: "password_policy_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "visible_to_everyone", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceCreateRequest>): PasswordPushFlowServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.passwordPolicyId = "";
        message.visibleToEveryone = false;
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceCreateRequest): PasswordPushFlowServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushFlowRule rule = 3 [deprecated = true] */ 3:
                    message.rule = PasswordPushFlowRule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
                    break;
                case /* string password_policy_id */ 4:
                    message.passwordPolicyId = reader.string();
                    break;
                case /* bool visible_to_everyone */ 5:
                    message.visibleToEveryone = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.password_push.v1.PasswordPushFlowRule rule = 3 [deprecated = true]; */
        if (message.rule)
            PasswordPushFlowRule.internalBinaryWrite(message.rule, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* string password_policy_id = 4; */
        if (message.passwordPolicyId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.passwordPolicyId);
        /* bool visible_to_everyone = 5; */
        if (message.visibleToEveryone !== false)
            writer.tag(5, WireType.Varint).bool(message.visibleToEveryone);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateRequest
 */
export const PasswordPushFlowServiceCreateRequest = new PasswordPushFlowServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCreateResponse$Type extends MessageType<PasswordPushFlowServiceCreateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCreateResponse", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceCreateResponse>): PasswordPushFlowServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceCreateResponse): PasswordPushFlowServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPushFlow password_push_flow */ 1:
                    message.passwordPushFlow = PasswordPushFlow.internalBinaryRead(reader, reader.uint32(), options, message.passwordPushFlow);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1; */
        if (message.passwordPushFlow)
            PasswordPushFlow.internalBinaryWrite(message.passwordPushFlow, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCreateResponse
 */
export const PasswordPushFlowServiceCreateResponse = new PasswordPushFlowServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceGetRequest$Type extends MessageType<PasswordPushFlowServiceGetRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceGetRequest>): PasswordPushFlowServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceGetRequest): PasswordPushFlowServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetRequest
 */
export const PasswordPushFlowServiceGetRequest = new PasswordPushFlowServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceGetResponse$Type extends MessageType<PasswordPushFlowServiceGetResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceGetResponse", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceGetResponse>): PasswordPushFlowServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceGetResponse): PasswordPushFlowServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPushFlow password_push_flow */ 1:
                    message.passwordPushFlow = PasswordPushFlow.internalBinaryRead(reader, reader.uint32(), options, message.passwordPushFlow);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1; */
        if (message.passwordPushFlow)
            PasswordPushFlow.internalBinaryWrite(message.passwordPushFlow, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceGetResponse
 */
export const PasswordPushFlowServiceGetResponse = new PasswordPushFlowServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceUpdateRequest$Type extends MessageType<PasswordPushFlowServiceUpdateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceUpdateRequest", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceUpdateRequest>): PasswordPushFlowServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceUpdateRequest): PasswordPushFlowServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPushFlow password_push_flow */ 1:
                    message.passwordPushFlow = PasswordPushFlow.internalBinaryRead(reader, reader.uint32(), options, message.passwordPushFlow);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1; */
        if (message.passwordPushFlow)
            PasswordPushFlow.internalBinaryWrite(message.passwordPushFlow, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateRequest
 */
export const PasswordPushFlowServiceUpdateRequest = new PasswordPushFlowServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceUpdateResponse$Type extends MessageType<PasswordPushFlowServiceUpdateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceUpdateResponse", [
            { no: 1, name: "password_push_flow", kind: "message", T: () => PasswordPushFlow }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceUpdateResponse>): PasswordPushFlowServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceUpdateResponse): PasswordPushFlowServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPushFlow password_push_flow */ 1:
                    message.passwordPushFlow = PasswordPushFlow.internalBinaryRead(reader, reader.uint32(), options, message.passwordPushFlow);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPushFlow password_push_flow = 1; */
        if (message.passwordPushFlow)
            PasswordPushFlow.internalBinaryWrite(message.passwordPushFlow, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceUpdateResponse
 */
export const PasswordPushFlowServiceUpdateResponse = new PasswordPushFlowServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceDeleteRequest$Type extends MessageType<PasswordPushFlowServiceDeleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceDeleteRequest>): PasswordPushFlowServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceDeleteRequest): PasswordPushFlowServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteRequest
 */
export const PasswordPushFlowServiceDeleteRequest = new PasswordPushFlowServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceDeleteResponse$Type extends MessageType<PasswordPushFlowServiceDeleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceDeleteResponse", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceDeleteResponse>): PasswordPushFlowServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceDeleteResponse): PasswordPushFlowServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceDeleteResponse
 */
export const PasswordPushFlowServiceDeleteResponse = new PasswordPushFlowServiceDeleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceInitiateRequest$Type extends MessageType<PasswordPushFlowServiceInitiateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceInitiateRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceInitiateRequest>): PasswordPushFlowServiceInitiateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.passwordPushFlowId = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceInitiateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceInitiateRequest): PasswordPushFlowServiceInitiateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string password_push_flow_id */ 2:
                    message.passwordPushFlowId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceInitiateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string password_push_flow_id = 2; */
        if (message.passwordPushFlowId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.passwordPushFlowId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateRequest
 */
export const PasswordPushFlowServiceInitiateRequest = new PasswordPushFlowServiceInitiateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceInitiateResponse$Type extends MessageType<PasswordPushFlowServiceInitiateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceInitiateResponse", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password_push_flow_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "jwk", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceInitiateResponse>): PasswordPushFlowServiceInitiateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.passwordPushFlowId = "";
        message.passwordPushFlowInvocationId = "";
        message.jwk = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceInitiateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceInitiateResponse): PasswordPushFlowServiceInitiateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string password_push_flow_id */ 2:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string password_push_flow_invocation_id */ 3:
                    message.passwordPushFlowInvocationId = reader.string();
                    break;
                case /* string jwk */ 4:
                    message.jwk = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceInitiateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string password_push_flow_id = 2; */
        if (message.passwordPushFlowId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string password_push_flow_invocation_id = 3; */
        if (message.passwordPushFlowInvocationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.passwordPushFlowInvocationId);
        /* string jwk = 4; */
        if (message.jwk !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.jwk);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceInitiateResponse
 */
export const PasswordPushFlowServiceInitiateResponse = new PasswordPushFlowServiceInitiateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCompleteRequest$Type extends MessageType<PasswordPushFlowServiceCompleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCompleteRequest", [
            { no: 1, name: "target_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "password_push_flow_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "password_push_flow_invocation_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "jwe_encrypted_password", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceCompleteRequest>): PasswordPushFlowServiceCompleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.targetUserId = "";
        message.passwordPushFlowId = "";
        message.passwordPushFlowInvocationId = "";
        message.jweEncryptedPassword = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceCompleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceCompleteRequest): PasswordPushFlowServiceCompleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string target_user_id */ 1:
                    message.targetUserId = reader.string();
                    break;
                case /* string password_push_flow_id */ 2:
                    message.passwordPushFlowId = reader.string();
                    break;
                case /* string password_push_flow_invocation_id */ 3:
                    message.passwordPushFlowInvocationId = reader.string();
                    break;
                case /* string jwe_encrypted_password */ 4:
                    message.jweEncryptedPassword = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceCompleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string target_user_id = 1; */
        if (message.targetUserId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.targetUserId);
        /* string password_push_flow_id = 2; */
        if (message.passwordPushFlowId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.passwordPushFlowId);
        /* string password_push_flow_invocation_id = 3; */
        if (message.passwordPushFlowInvocationId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.passwordPushFlowInvocationId);
        /* string jwe_encrypted_password = 4; */
        if (message.jweEncryptedPassword !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.jweEncryptedPassword);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteRequest
 */
export const PasswordPushFlowServiceCompleteRequest = new PasswordPushFlowServiceCompleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPushFlowServiceCompleteResponse$Type extends MessageType<PasswordPushFlowServiceCompleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPushFlowServiceCompleteResponse", []);
    }
    create(value?: PartialMessage<PasswordPushFlowServiceCompleteResponse>): PasswordPushFlowServiceCompleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPushFlowServiceCompleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPushFlowServiceCompleteResponse): PasswordPushFlowServiceCompleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPushFlowServiceCompleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPushFlowServiceCompleteResponse
 */
export const PasswordPushFlowServiceCompleteResponse = new PasswordPushFlowServiceCompleteResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceCreateRequest$Type extends MessageType<PasswordPolicyServiceCreateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceCreateRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "rule", kind: "message", T: () => PasswordPushFlowRule }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceCreateRequest>): PasswordPolicyServiceCreateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceCreateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceCreateRequest): PasswordPolicyServiceCreateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.api.password_push.v1.PasswordPushFlowRule rule */ 3:
                    message.rule = PasswordPushFlowRule.internalBinaryRead(reader, reader.uint32(), options, message.rule);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceCreateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.api.password_push.v1.PasswordPushFlowRule rule = 3; */
        if (message.rule)
            PasswordPushFlowRule.internalBinaryWrite(message.rule, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateRequest
 */
export const PasswordPolicyServiceCreateRequest = new PasswordPolicyServiceCreateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceCreateResponse$Type extends MessageType<PasswordPolicyServiceCreateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceCreateResponse", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceCreateResponse>): PasswordPolicyServiceCreateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceCreateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceCreateResponse): PasswordPolicyServiceCreateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPolicy password_policy */ 1:
                    message.passwordPolicy = PasswordPolicy.internalBinaryRead(reader, reader.uint32(), options, message.passwordPolicy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceCreateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPolicy password_policy = 1; */
        if (message.passwordPolicy)
            PasswordPolicy.internalBinaryWrite(message.passwordPolicy, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceCreateResponse
 */
export const PasswordPolicyServiceCreateResponse = new PasswordPolicyServiceCreateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceGetRequest$Type extends MessageType<PasswordPolicyServiceGetRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceGetRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceGetRequest>): PasswordPolicyServiceGetRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceGetRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceGetRequest): PasswordPolicyServiceGetRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceGetRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetRequest
 */
export const PasswordPolicyServiceGetRequest = new PasswordPolicyServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceGetResponse$Type extends MessageType<PasswordPolicyServiceGetResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceGetResponse", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceGetResponse>): PasswordPolicyServiceGetResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceGetResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceGetResponse): PasswordPolicyServiceGetResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPolicy password_policy */ 1:
                    message.passwordPolicy = PasswordPolicy.internalBinaryRead(reader, reader.uint32(), options, message.passwordPolicy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceGetResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPolicy password_policy = 1; */
        if (message.passwordPolicy)
            PasswordPolicy.internalBinaryWrite(message.passwordPolicy, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceGetResponse
 */
export const PasswordPolicyServiceGetResponse = new PasswordPolicyServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceUpdateRequest$Type extends MessageType<PasswordPolicyServiceUpdateRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceUpdateRequest", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceUpdateRequest>): PasswordPolicyServiceUpdateRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceUpdateRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceUpdateRequest): PasswordPolicyServiceUpdateRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPolicy password_policy */ 1:
                    message.passwordPolicy = PasswordPolicy.internalBinaryRead(reader, reader.uint32(), options, message.passwordPolicy);
                    break;
                case /* google.protobuf.FieldMask update_mask */ 2:
                    message.updateMask = FieldMask.internalBinaryRead(reader, reader.uint32(), options, message.updateMask);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceUpdateRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPolicy password_policy = 1; */
        if (message.passwordPolicy)
            PasswordPolicy.internalBinaryWrite(message.passwordPolicy, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FieldMask update_mask = 2; */
        if (message.updateMask)
            FieldMask.internalBinaryWrite(message.updateMask, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateRequest
 */
export const PasswordPolicyServiceUpdateRequest = new PasswordPolicyServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceUpdateResponse$Type extends MessageType<PasswordPolicyServiceUpdateResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceUpdateResponse", [
            { no: 1, name: "password_policy", kind: "message", T: () => PasswordPolicy }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceUpdateResponse>): PasswordPolicyServiceUpdateResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceUpdateResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceUpdateResponse): PasswordPolicyServiceUpdateResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.password_push.v1.PasswordPolicy password_policy */ 1:
                    message.passwordPolicy = PasswordPolicy.internalBinaryRead(reader, reader.uint32(), options, message.passwordPolicy);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceUpdateResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.password_push.v1.PasswordPolicy password_policy = 1; */
        if (message.passwordPolicy)
            PasswordPolicy.internalBinaryWrite(message.passwordPolicy, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceUpdateResponse
 */
export const PasswordPolicyServiceUpdateResponse = new PasswordPolicyServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceDeleteRequest$Type extends MessageType<PasswordPolicyServiceDeleteRequest> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceDeleteRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<PasswordPolicyServiceDeleteRequest>): PasswordPolicyServiceDeleteRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceDeleteRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceDeleteRequest): PasswordPolicyServiceDeleteRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceDeleteRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteRequest
 */
export const PasswordPolicyServiceDeleteRequest = new PasswordPolicyServiceDeleteRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PasswordPolicyServiceDeleteResponse$Type extends MessageType<PasswordPolicyServiceDeleteResponse> {
    constructor() {
        super("c1.api.password_push.v1.PasswordPolicyServiceDeleteResponse", []);
    }
    create(value?: PartialMessage<PasswordPolicyServiceDeleteResponse>): PasswordPolicyServiceDeleteResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<PasswordPolicyServiceDeleteResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: PasswordPolicyServiceDeleteResponse): PasswordPolicyServiceDeleteResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: PasswordPolicyServiceDeleteResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.password_push.v1.PasswordPolicyServiceDeleteResponse
 */
export const PasswordPolicyServiceDeleteResponse = new PasswordPolicyServiceDeleteResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPushFlowService
 */
export const PasswordPushFlowService = new ServiceType("c1.api.password_push.v1.PasswordPushFlowService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowServiceCreateRequest, O: PasswordPushFlowServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowServiceGetRequest, O: PasswordPushFlowServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowServiceUpdateRequest, O: PasswordPushFlowServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPushFlowServiceDeleteRequest, O: PasswordPushFlowServiceDeleteResponse },
    { name: "Initiate", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowServiceInitiateRequest, O: PasswordPushFlowServiceInitiateResponse },
    { name: "Complete", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPushFlowServiceCompleteRequest, O: PasswordPushFlowServiceCompleteResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.password_push.v1.PasswordPolicyService
 */
export const PasswordPolicyService = new ServiceType("c1.api.password_push.v1.PasswordPolicyService", [
    { name: "Create", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPolicyServiceCreateRequest, O: PasswordPolicyServiceCreateResponse },
    { name: "Get", options: { "authz.method": { role: "VIEWER" } }, I: PasswordPolicyServiceGetRequest, O: PasswordPolicyServiceGetResponse },
    { name: "Update", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPolicyServiceUpdateRequest, O: PasswordPolicyServiceUpdateResponse },
    { name: "Delete", options: { "authz.method": { role: "EDITOR" } }, I: PasswordPolicyServiceDeleteRequest, O: PasswordPolicyServiceDeleteResponse }
]);
